<img
  [src]="'/assets/images/destination-icons/' + key + '-logo.svg' | ssrEmptyString"
  alt="destination icon"
  *ngIf="key"
  corporateImageLazyLoad
/>
